import { type Cohort } from 'Cohorts';

// since cohort_id and cohort_version_id are the keys of a record in IndexedDB, it cannot be null
export default function cohortKeysForStudentDashboardFetch(cohort?: Pick<Cohort, 'id' | 'versionId'> | null) {
    return {
        cohortId: cohort?.id ?? 'none',
        cohortVersionId: cohort?.versionId ?? 'none',
    };
}
